
import React, { useState, useEffect, useRef } from "react";
import {
    Box, Card, CardContent, Typography, TextField,
    MenuItem, Button, Chip, FormControl, Select,
    InputAdornment, Divider, Slider,
    Dialog, DialogTitle, DialogContent, DialogActions,
    IconButton, Radio
} from "@mui/material";
import { X, ArrowLeft, ArrowRight } from "lucide-react";
// import { GOOGLE_MAPS_API_KEY, RAZORPAY_KEY_ID } from "../../../config/api";
// ✅ Google Maps
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
// import { createCampaign } from "../../../Service/APIServices/campaignService";
// import { getBillingConfig } from "../../../Service/APIServices/campaignService";
const BudgetReview = ({
    currentStep,
    formData,
    goals,
    subGoals,
    onInputChange,
    onMultiSelect,
    onNext,
    onBack,
    onPayment,
    isStepValid,
    isPaymentValid,
    isBudgetStep,
    showPayment,        // ✅ from parent
    setShowPayment,      // ✅ from parent
    adPreviewRef
}) => {
    const [durationType, setDurationType] = useState("continuous"); // continuous | fixed
    const FIXED_AMOUNT = 1000;
    // 🔥 Add this at top of component data not Founded in the real time allowing data not founded in the real time examples and the inventory categories that will usefull in the 
    const PRICE_PER_DAY = 100;
    const COST_PER_REACH = 0.5;
    const days = parseInt(formData.days) || 1;
    const reach = parseInt(formData.reach) || 1000;
    const totalPrice = (days * PRICE_PER_DAY) + (reach * COST_PER_REACH);
    const dailyCost = totalPrice / days;
    const gst = totalPrice * 0.18;
    const finalAmount = totalPrice + gst;
    const REACH_PER_RUPEE = 0.05;  // 1₹ = 0.05 users
    // ✅ Google Maps
    const baseInvestment = parseInt(formData.baseInvestment || 0);

    const INVESTMENT_STEP = 100;

    const MAX_LIMIT = baseInvestment + 10000;
    // const [showPayment, setShowPayment] = useState(false);
    const REACH_STEP = 100;
    const { isLoaded } = useJsApiLoader({
        // googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: ["places"]
    });
    // base reach derived from base investment
    const baseReach = Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP;
    // ✅ Area map states
    const [showAreaMap, setShowAreaMap] = useState(false);
    const [areaMapCenter, setAreaMapCenter] = useState({ lat: 28.6139, lng: 77.209 });
    const [billing, setBilling] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const isBrandingDigital =
        formData.goal?.toLowerCase() === "branding" &&
        formData.mediums?.includes("digital");
    const isDaysUpdate = useRef(false);


    // 1️⃣ When DAYS change → update investment only (no reach)
    useEffect(() => {
        const fetchBilling = () => {
        
        };

        fetchBilling();
    }, [formData.goal, formData.mediums]);


    useEffect(() => {

        if (!billing) return;

        let total = 0;

        const mediums =
            formData.mediums || [];

        const placements =
            formData.placements || [];

        const audience =
            formData.audience || [];

        const mediaTypes =
            formData.mediaTypes || [];

        const screenCount =
            placements.length || 1;

        const isBrandingDigital =
            formData.goal?.toLowerCase() ===
            "branding" &&
            mediums.includes("digital");

        const isDiscountCoupons =
            formData.goal?.toLowerCase() ===
            "discount" &&
            formData.subGoal?.toLowerCase() ===
            "coupons";

        let calculationDetails = "";

        // =====================================================
        // ✅ BRANDING + DIGITAL
        // =====================================================

        if (isBrandingDigital) {

            let digitalCharge = 0;

            // ✅ VIDEO
            if (
                mediaTypes.some(
                    (type) =>
                        type?.toLowerCase() ===
                        "video"
                )
            ) {

                digitalCharge =
                    Number(
                        billing?.digialScreenChargevideo
                    ) || 0;

                calculationDetails +=
                    `Video Screen Charge: ${digitalCharge}\n`;
            }

            // ✅ IMAGE
            else if (
                mediaTypes.some(
                    (type) =>
                        type?.toLowerCase() ===
                        "image"
                )
            ) {

                digitalCharge =
                    Number(
                        billing?.digitalScreenChargeimage
                    ) || 0;

                calculationDetails +=
                    `Image Screen Charge: ${digitalCharge}\n`;
            }

            // ✅ Duration Charge
            const seconds =
                Number(
                    formData.durationSeconds
                ) || 1;

            const secondsCharge =
                Number(
                    billing?.digitalScreenSecondsCharge
                ) || 0;

            const durationAmount =
                seconds * secondsCharge;

            calculationDetails +=
                `Duration Charge: ${seconds} x ${secondsCharge} = ${durationAmount}\n`;

            // ✅ Screen Position Charge
            const displayScreenCharge =
                (Number(
                    billing?.displayPositionScreensCharge
                ) || 0) * screenCount;

            calculationDetails +=
                `Display Position Screens Charge: ${billing?.displayPositionScreensCharge} x ${screenCount} = ${displayScreenCharge}\n`;

            // ✅ Final Base
            // ✅ DAYS
            const days =
                Number(formData.days || 1);

            // ✅ Final Base
            const baseAmount =
                (
                    digitalCharge +
                    durationAmount
                ) * screenCount;

            // ✅ FINAL TOTAL WITH DAYS
            total =
                (
                    baseAmount +
                    displayScreenCharge
                ) * days;

            calculationDetails +=
                `Days Charge: (${baseAmount} + ${displayScreenCharge}) x ${days} = ${total}\n`;
        }

        // =====================================================
        // ✅ NORMAL LOGIC
        // =====================================================

        else {

            // ✅ Media Type Charge
            if (mediaTypes.length > 0) {

                let mediaTypePrice = 0;

                // IMAGE
                if (
                    mediaTypes.some(
                        (type) =>
                            type?.toLowerCase() ===
                            "image"
                    )
                ) {

                    mediaTypePrice =
                        Number(
                            billing?.mediaTypeCharge
                        ) || 0;

                    calculationDetails +=
                        `Image Media Type Charge: ${mediaTypePrice}\n`;
                }

                // VIDEO
                else if (
                    mediaTypes.some(
                        (type) =>
                            type?.toLowerCase() ===
                            "video"
                    )
                ) {

                    mediaTypePrice =
                        Number(
                            billing?.mediaTypeChargevideo
                        ) || 0;

                    calculationDetails +=
                        `Video Media Type Charge: ${mediaTypePrice}\n`;
                }

                const mediaTypeCost =
                    mediaTypePrice *
                    mediaTypes.length;

                total += mediaTypeCost;

                calculationDetails +=
                    `Media Type Total: ${mediaTypePrice} x ${mediaTypes.length} = ${mediaTypeCost}\n`;
            }

            // ✅ Audience Charge
            if (audience.length > 0) {

                const audienceCost =
                    (Number(
                        billing?.targetAudiencesCharge
                    ) || 0) *
                    audience.length;

                total += audienceCost;

                calculationDetails +=
                    `Audience Charge: ${billing?.targetAudiencesCharge} x ${audience.length} = ${audienceCost}\n`;
            }

            // ✅ Placement Charge
            if (placements.length > 0) {

                const placementCost =
                    (Number(
                        billing?.displaypPositionCharge
                    ) || 0) *
                    placements.length;

                total += placementCost;

                calculationDetails +=
                    `Placement Charge: ${billing?.displaypPositionCharge} x ${placements.length} = ${placementCost}\n`;
            }

            // ✅ Coupon Charge
            // ✅ Coupon Charge
            if (isDiscountCoupons) {

                const couponCharge =
                    Number(
                        billing?.couponCharge
                    ) || 0;

                total += couponCharge;

                calculationDetails +=
                    `Coupon Charge: ${couponCharge}\n`;
            }

            // ✅ APPLY DAYS FOR ALL NON BRANDING INVESTMENTS
            const days =
                Number(formData.days || 1);

            total = total * days;

            calculationDetails +=
                `Days Charge: ${total / days} x ${days} = ${total}\n`;

            calculationDetails +=
                `Final Total: ${total}`;
        }

        calculationDetails +=
            `Final Total: ${total}`;



        // ✅ UPDATE VALUES
        onInputChange(
            "baseInvestment",
            total
        );

        onInputChange(
            "investment",
            total
        );

    }, [
        billing,
        formData.mediums,
        formData.placements,
        formData.audience,
        formData.mediaTypes,
        formData.goal,
        formData.subGoal,
        formData.durationSeconds,
        formData.days
    ]);

    // useEffect(() => {
    //     if (!billing) return;

    //     let total = 0;

    //     const mediums = formData.mediums || [];
    //     const placements = formData.placements || [];
    //     const audience = formData.audience || [];
    //     const mediaTypes = formData.mediaTypes || [];

    //     let calculationDetails = "";

    //     const isBrandingDigital =
    //         formData.goal?.toLowerCase() ===
    //         "branding" &&
    //         mediums.includes("digital");

    //     const isDiscountCoupons =
    //         formData.goal?.toLowerCase() ===
    //         "discount" &&
    //         formData.subGoal?.toLowerCase() ===
    //         "coupons";

    //     // ✅ Media Type Charge
    //     if (mediaTypes.length > 0) {

    //         let mediaTypePrice = 0;

    //         // ✅ IMAGE
    //         if (
    //             mediaTypes.some(
    //                 (type) =>
    //                     type?.toLowerCase() === "image"
    //             )
    //         ) {
    //             mediaTypePrice =
    //                 Number(
    //                     billing.mediaTypeCharge
    //                 ) || 0;

    //             calculationDetails +=
    //                 `Image Media Type Charge: ${mediaTypePrice}\n`;
    //         }

    //         // ✅ VIDEO
    //         else if (
    //             mediaTypes.some(
    //                 (type) =>
    //                     type?.toLowerCase() === "video"
    //             )
    //         ) {
    //             mediaTypePrice =
    //                 Number(
    //                     billing.mediaTypeChargevideo
    //                 ) || 0;

    //             calculationDetails +=
    //                 `Video Media Type Charge: ${mediaTypePrice}\n`;
    //         }

    //         const mediaTypeCost =
    //             mediaTypePrice *
    //             mediaTypes.length;

    //         total += mediaTypeCost;

    //         calculationDetails +=
    //             `Media Type Total: ${mediaTypePrice} x ${mediaTypes.length} = ${mediaTypeCost}\n`;
    //     }

    //     // ✅ Audience Charge
    //     if (audience.length > 0) {

    //         const audienceCost =
    //             billing.targetAudiencesCharge *
    //             audience.length;

    //         total += audienceCost;

    //         calculationDetails +=
    //             `Audience Charge: ${billing.targetAudiencesCharge} x ${audience.length} = ${audienceCost}\n`;
    //     }

    //     // =====================================================
    //     // ✅ Placement Charge ONLY FOR
    //     // LEADS + DISCOUNT
    //     // =====================================================

    //     if (
    //         placements.length > 0 &&
    //         !isBrandingDigital
    //     ) {

    //         const placementCost =
    //             (Number(
    //                 billing?.displaypPositionCharge
    //             ) || 0) *
    //             placements.length;

    //         total += placementCost;

    //         calculationDetails +=
    //             `Placement Charge: ${billing?.displaypPositionCharge} x ${placements.length} = ${placementCost}\n`;
    //     }

    //     // =====================================================
    //     // ✅ ADD COUPON CHARGE ONLY FOR
    //     // GOAL = DISCOUNT
    //     // SUBGOAL = COUPONS
    //     // =====================================================

    //     if (isDiscountCoupons) {

    //         const couponCharge =
    //             Number(
    //                 billing?.couponCharge
    //             ) || 0;

    //         total += couponCharge;

    //         calculationDetails +=
    //             `Coupon Charge: ${couponCharge}\n`;
    //     }

    //     // ✅ Digital Charges
    //     if (mediums.includes("digital")) {

    //         const screenCount =
    //             placements.length || 1;

    //         let pricePerScreen = 0;

    //         // ✅ VIDEO
    //         if (
    //             mediaTypes.some(
    //                 (type) =>
    //                     type?.toLowerCase() === "video"
    //             )
    //         ) {
    //             pricePerScreen =
    //                 Number(
    //                     billing?.digialScreenChargevideo
    //                 ) || 0;

    //             calculationDetails +=
    //                 `Video Screen Charge: ${pricePerScreen}\n`;
    //         }

    //         // ✅ IMAGE
    //         else if (
    //             mediaTypes.some(
    //                 (type) =>
    //                     type?.toLowerCase() === "image"
    //             )
    //         ) {
    //             pricePerScreen =
    //                 Number(
    //                     billing?.digitalScreenChargeimage
    //                 ) || 0;

    //             calculationDetails +=
    //                 `Image Screen Charge: ${pricePerScreen}\n`;
    //         }

    //         // ✅ GOAL BRANDING + DIGITAL
    //         // Use displayPositionScreensCharge
    //         let placementScreenCharge = 0;

    //         if (
    //             formData.goal?.toLowerCase() === "branding"
    //         ) {

    //             placementScreenCharge =
    //                 (Number(
    //                     billing?.displayPositionScreensCharge
    //                 ) || 0) * screenCount;

    //             total += placementScreenCharge;

    //             calculationDetails +=
    //                 `Display Position Screens Charge: ${billing?.displayPositionScreensCharge} x ${screenCount} = ${placementScreenCharge}\n`;
    //         }

    //         const baseAmount =
    //             screenCount *
    //             Number(pricePerScreen);

    //         total += baseAmount;

    //         calculationDetails +=
    //             `Base Amount: ${screenCount} x ${pricePerScreen} = ${baseAmount}\n`;
    //     }

    //     calculationDetails +=
    //         `Final Total: ${total}`;

    //     // ✅ Alert Box
    //     alert(calculationDetails);

    //     // ✅ Update Values
    //     onInputChange("baseInvestment", total);

    //     if (!formData.investment) {
    //         onInputChange("investment", total);
    //     }

    // }, [
    //     billing,
    //     formData.mediums,
    //     formData.placements,
    //     formData.audience,
    //     formData.mediaTypes,
    //     formData.goal,
    //     formData.subGoal,
    // ]);


    // ❌ DELETE the third useEffect that also watches formData.investment — REMOVE IT ENTIRELY 

    const handlePayment = () => {
        const options = {
            amount: Math.round(finalAmount * 100),
            currency: "INR",
            name: "Maamaas",
            description: "Ad Campaign Payment",

            // ✅ FIX: make handler async and await handleSubmit
            handler: async function (response) {

                try {
                    await handleSubmit(); // ✅ AWAIT it
                    alert("✅ Payment & Campaign Created Successfully!");
                } catch (err) {
                    //console.error("❌ handleSubmit failed after payment:", err);
                    alert("⚠️ Payment done but campaign creation failed: " + err.message);
                }
            },

            prefill: {
                name: "Naresh",
                email: "test@example.com",
                contact: "9999999999"
            },
            theme: { color: "#2563eb" }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };

    const handleSubmit = () => {

    };








    const getCurrentAreaLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(pos => {
                setAreaMapCenter({
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude
                });
            });
        }
    };

    // ================= BUDGET STEP =================
    {/* ── Budget Section ── */ }
    if (isBudgetStep) {
        return (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
                <Card elevation={3} sx={{ borderRadius: "16px", border: "1px solid #4f46e5" }}>
                    <CardContent sx={{ p: { xs: 3, md: 4 } }}>

                        {/* HEADER (COMMON FOR BOTH) */}
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>

                            {/* <Chip label="Step 4/3" color="primary" variant="outlined" /> */}
                        </Box>

                        {/* ✅ CONDITION START */}
                        {(
                            formData.goal?.toLowerCase() === "discount" ||
                            formData.subGoal?.toLowerCase() === "coupons"
                        ) ? (

                            /* ================= DISCOUNT ONLY ================= */


                            <Box sx={{ p: { xs: 2, md: 3, borderRadius: "16px", } }}>
                                <Card elevation={3} sx={{ marginTop: "-63px", borderRadius: "16px", background: "transparent", boxShadow: "none" }}>
                                    <CardContent sx={{ p: { xs: 3, md: 4, } }}>

                                        {/* ✅ MAIN ROW */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",   // ✅ MAIN FIX various data not founded in the real 
                                                gap: 3
                                            }}
                                        >

                                            {/* 🔵 Investment */}
                                            <Box>
                                                {/* Header */}
                                                <Box sx={{ mb: 2 }}>
                                                    {/* 🔥 Top Label */}
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 600, mb: 1 }}>
                                                        Investment
                                                    </Typography>

                                                    {/* 🔽 Bottom Row (Value + Input) */}
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            gap: 2
                                                        }}
                                                    >


                                                        <TextField
                                                            size="small"
                                                            type="number"
                                                            value={formData.investment ?? ""}
                                                            placeholder="Enter amount"

                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                if (value === "") {
                                                                    onInputChange("investment", "");
                                                                    return;
                                                                }

                                                                const num = Number(value);
                                                                onInputChange("investment", num);

                                                                if (!isNaN(num)) {
                                                                    const steps = (num - baseInvestment) / INVESTMENT_STEP;

                                                                    const newReach =
                                                                        Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                        steps * REACH_STEP;

                                                                    if (!isDaysUpdate.current) {
                                                                        onInputChange("reach", newReach);
                                                                    }
                                                                }
                                                            }}

                                                            onBlur={() => {
                                                                let value = Number(formData.investment);

                                                                if (!value || value < baseInvestment) {
                                                                    value = baseInvestment;
                                                                }

                                                                if (value > MAX_LIMIT) {
                                                                    value = MAX_LIMIT;
                                                                }

                                                                onInputChange("investment", value);

                                                                const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                                const newReach =
                                                                    Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                    steps * REACH_STEP;

                                                                onInputChange("reach", newReach);
                                                            }}

                                                            inputProps={{ min: 0 }}

                                                            sx={{ width: "180px" }}
                                                        />
                                                        {/* Value */}
                                                        <Typography sx={{ fontWeight: 700, color: "#1e40af" }}>
                                                            ₹{formData.investment || 0}
                                                        </Typography>

                                                        {/* Input */}

                                                    </Box>
                                                </Box>

                                                {/* Slider */}
                                                <Slider
                                                    value={
                                                        formData.investment === "" || formData.investment < baseInvestment
                                                            ? baseInvestment
                                                            : Number(formData.investment)
                                                    }
                                                    min={baseInvestment}
                                                    max={MAX_LIMIT}
                                                    step={INVESTMENT_STEP}
                                                    onChange={(e, val) => {
                                                        const value = Number(val);

                                                        onInputChange("investment", value);

                                                        const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                        const newReach =
                                                            Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                            steps * REACH_STEP;

                                                        onInputChange("reach", newReach);
                                                    }}
                                                    sx={{ color: "#3b82f6" }}
                                                />

                                                {/* Footer */}
                                                <Typography sx={{ fontSize: "11px", color: "#6b7280" }}>
                                                    Minimum budget: ₹{baseInvestment}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                                                        Reach
                                                    </Typography>
                                                    <Typography sx={{ fontWeight: 700, color: "#059669" }}>
                                                        {/* ✅ formData.reach is now set on load, so always shows correctly */}
                                                        {Number(formData.reach ?? billing?.reach ?? 0).toLocaleString()} users
                                                    </Typography>
                                                </Box>

                                                <Slider
                                                    value={Number(formData.reach ?? billing?.reach ?? 0)}
                                                    min={billing?.reach ?? 0}
                                                    max={10000}
                                                    step={REACH_STEP}
                                                    onChange={(e, val) => {
                                                        onInputChange("reach", val);

                                                        const steps = (val - (billing?.reach ?? 0)) / REACH_STEP;
                                                        const newInvestment = baseInvestment + steps * INVESTMENT_STEP;
                                                        onInputChange("investment", newInvestment);
                                                    }}
                                                    sx={{ color: "#10b981" }}
                                                />
                                            </Box>
                                            {/* 🟣 Duration */}
                                            <Box sx={{ mt: 3 }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        mb: 1
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "13px",
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        Duration
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontWeight: 700,
                                                            color: "#1e40af"
                                                        }}
                                                    >
                                                        {formData.days || 0} days
                                                    </Typography>
                                                </Box>

                                                <Slider
                                                    value={formData.days || 0}
                                                    min={1}
                                                    max={30}
                                                    disabled
                                                    sx={{
                                                        color: "#8b5cf6"
                                                    }}
                                                />
                                            </Box>

                                            {/* 🟢 Reach */}


                                        </Box>
                                        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>

                                            {/* Start Date */}
                                            <Box sx={{ flex: 1 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        color: "#374151",
                                                        mb: 0.8
                                                    }}
                                                >
                                                    Start Date
                                                </Typography>

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type="date"
                                                    value={formData.startDate}
                                                    onChange={(e) => {

                                                        const startDate = e.target.value;

                                                        onInputChange("startDate", startDate);

                                                        // AUTO CALCULATE DAYS
                                                        if (formData.endDate) {

                                                            const start = new Date(startDate);
                                                            const end = new Date(formData.endDate);

                                                            const diffTime = end - start;

                                                            const diffDays =
                                                                Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                                            if (diffDays >= 0) {
                                                                onInputChange("days", diffDays);
                                                            }
                                                        }
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{
                                                        min: new Date().toISOString().split("T")[0]
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "12px",
                                                            backgroundColor: "#f8fafc"
                                                        }
                                                    }}
                                                />
                                            </Box>

                                            {/* END DATE */}
                                            <Box sx={{ flex: 1 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        color: "#374151",
                                                        mb: 0.8
                                                    }}
                                                >
                                                    End Date
                                                </Typography>

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type="date"
                                                    value={formData.endDate}
                                                    onChange={(e) => {

                                                        const endDate = e.target.value;

                                                        onInputChange("endDate", endDate);

                                                        // AUTO CALCULATE DAYS
                                                        if (formData.startDate) {

                                                            const start = new Date(formData.startDate);
                                                            const end = new Date(endDate);

                                                            const diffTime = end - start;

                                                            const diffDays =
                                                                Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                                            if (diffDays >= 0) {
                                                                onInputChange("days", diffDays);
                                                            }
                                                        }
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{
                                                        min:
                                                            formData.startDate ||
                                                            new Date().toISOString().split("T")[0]
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "12px",
                                                            backgroundColor: "#f8fafc"
                                                        }
                                                    }}
                                                />
                                            </Box>

                                        </Box>


                                        <Divider sx={{ mb: 3 }} />

                                        {/* ── Dates Section ── */}




                                        {/* ✅ Selected Locations Tags */}
                                        {formData.targetLocations?.length > 0 && (
                                            <Box sx={{
                                                p: 2, backgroundColor: "#f8fafc",
                                                border: "1px solid #e2e8f0", borderRadius: "10px", mb: 3
                                            }}>
                                                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#6b7280", mb: 1.5 }}>
                                                    📍 {formData.targetLocations.length} Location(s) Selected
                                                </Typography>
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                    {formData.targetLocations.map((loc, idx) => (
                                                        <Chip
                                                            key={idx}
                                                            label={`📍 ${loc.name}`}
                                                            onDelete={() => {
                                                                const updated = formData.targetLocations.filter((_, i) => i !== idx);
                                                                onInputChange("targetLocations", updated);
                                                            }}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "#eff6ff", color: "#1e40af",
                                                                fontWeight: 600, fontSize: "12px",
                                                                border: "1px solid #bfdbfe", borderRadius: "8px",
                                                                "& .MuiChip-deleteIcon": { color: "#3b82f6" }
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}



                                        {/* ── Navigation ── */}
                                        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, }}>
                                            <Button
                                                variant="outlined" size="large"
                                                startIcon={<ArrowLeft size={18} />}
                                                onClick={onBack}
                                                sx={{
                                                    borderRadius: "10px", textTransform: "none", fontWeight: 600,
                                                    borderColor: "#e5e7eb", color: "#6b7280",
                                                    "&:hover": { backgroundColor: "#f9fafb", borderColor: "#d1d5db" }
                                                }}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                disabled={isSubmitted} // 🔥 disables button after click
                                                onClick={() => {
                                                    setIsSubmitted(true);
                                                    setShowPayment(true);

                                                    setTimeout(() => {
                                                        if (adPreviewRef?.current) {
                                                            const container = adPreviewRef.current;

                                                            container.scrollTo({
                                                                top: container.scrollHeight,
                                                                behavior: "smooth"
                                                            });
                                                        }
                                                    }, 100);
                                                }}
                                                sx={{
                                                    borderRadius: "10px",
                                                    textTransform: "none",
                                                    fontWeight: 600,
                                                    backgroundColor: isSubmitted ? "#cbd5f5" : "#f97316", // disabled color
                                                    color: "#fff",
                                                    "&:hover": {
                                                        backgroundColor: isSubmitted ? "#cbd5f5" : "#ea580c"
                                                    }
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </Box>

                                    </CardContent>
                                </Card>



                            </Box>

                        ) : formData.goal?.toLowerCase() === "branding" ? (

                            /* ================= BRANDING DATA ================= */
                            <Box sx={{ p: { xs: 2, md: 3, borderRadius: "16px", } }}>
                                <Card elevation={3} sx={{ marginTop: "-63px", borderRadius: "16px", background: "transparent", boxShadow: "none" }}>
                                    <CardContent sx={{ p: { xs: 3, md: 4, } }}>

                                        {/* ✅ MAIN ROW */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",   // ✅ MAIN FIX various data not founded in the real 
                                                gap: 3
                                            }}
                                        >
                                            {isBrandingDigital && (
                                                <Typography sx={{ fontSize: "12px", color: "#059669", mt: 1 }}>
                                                    <Box>
                                                        {/* Header */}
                                                        <Box sx={{ mb: 2 }}>
                                                            {/* 🔥 Top Label Branding Investment */}
                                                            <Typography sx={{ fontSize: "13px", fontWeight: 600, mb: 1 }}>
                                                                Investment
                                                            </Typography>

                                                            {/* 🔽 Bottom Row (Value + Input) */}
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    gap: 2
                                                                }}
                                                            >


                                                                <TextField
                                                                    size="small"
                                                                    type="number"
                                                                    value={formData.investment ?? ""}
                                                                    placeholder="Enter amount"

                                                                    onChange={(e) => {
                                                                        const value = e.target.value;

                                                                        if (value === "") {
                                                                            onInputChange("investment", "");
                                                                            return;
                                                                        }

                                                                        const num = Number(value);
                                                                        onInputChange("investment", num);

                                                                        if (!isNaN(num)) {
                                                                            const steps = (num - baseInvestment) / INVESTMENT_STEP;

                                                                            const newReach =
                                                                                Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                                steps * REACH_STEP;

                                                                            onInputChange("reach", newReach);
                                                                        }
                                                                    }}

                                                                    onBlur={() => {
                                                                        let value = Number(formData.investment);

                                                                        if (!value || value < baseInvestment) {
                                                                            value = baseInvestment;
                                                                        }

                                                                        if (value > MAX_LIMIT) {
                                                                            value = MAX_LIMIT;
                                                                        }

                                                                        onInputChange("investment", value);

                                                                        const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                                        const newReach =
                                                                            Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                            steps * REACH_STEP;

                                                                        onInputChange("reach", newReach);
                                                                    }}

                                                                    inputProps={{ min: 0 }}

                                                                    sx={{ width: "180px" }}
                                                                />
                                                                {/* Value */}
                                                                <Typography sx={{ fontWeight: 700, color: "#1e40af" }}>
                                                                    ₹{formData.investment || 0}
                                                                </Typography>

                                                                {/* Input */}

                                                            </Box>
                                                        </Box>

                                                        {/* Slider */}
                                                        <Slider
                                                            value={
                                                                formData.investment === "" || formData.investment < baseInvestment
                                                                    ? baseInvestment
                                                                    : Number(formData.investment)
                                                            }
                                                            min={baseInvestment}
                                                            max={MAX_LIMIT}
                                                            step={INVESTMENT_STEP}
                                                            onChange={(e, val) => {
                                                                const value = Number(val);

                                                                onInputChange("investment", value);   // ❌ THIS LINE CAUSES ISSUE

                                                                const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                                const newReach =
                                                                    Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                    steps * REACH_STEP;

                                                                onInputChange("reach", newReach);
                                                            }}
                                                        />
                                                        {/* Footer */}
                                                        {/* <Typography sx={{ fontSize: "11px", color: "#6b7280" }}>
                                                            Minimum budget: ₹{baseInvestment}
                                                        </Typography> */}


                                                        <Box sx={{ mt: 3 }}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    mb: 1
                                                                }}
                                                            >
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "13px",
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    Duration
                                                                </Typography>

                                                                <Typography
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: "#1e40af"
                                                                    }}
                                                                >
                                                                    {formData.days || 0} days
                                                                </Typography>
                                                            </Box>

                                                            <Slider
                                                                value={formData.days || 0}
                                                                min={0}
                                                                max={30}
                                                                disabled
                                                                sx={{
                                                                    color: "#8b5cf6"
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Typography>
                                            )}

                                            {/* 🔵 Investment */}




                                            {!isBrandingDigital && (
                                                <>
                                                    <Box>
                                                        {/* Header */}
                                                        <Box sx={{ mb: 2 }}>
                                                            {/* 🔥 Top Label */}
                                                            <Typography sx={{ fontSize: "13px", fontWeight: 600, mb: 1 }}>
                                                                Investment
                                                            </Typography>

                                                            {/* 🔽 Bottom Row (Value + Input) */}
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    gap: 2
                                                                }}
                                                            >


                                                                <TextField
                                                                    size="small"
                                                                    type="number"
                                                                    value={formData.investment ?? ""}
                                                                    placeholder="Enter amount"

                                                                    onChange={(e) => {
                                                                        const value = e.target.value;

                                                                        if (value === "") {
                                                                            onInputChange("investment", "");
                                                                            return;
                                                                        }

                                                                        const num = Number(value);
                                                                        onInputChange("investment", num);

                                                                        if (!isNaN(num)) {
                                                                            const steps = (num - baseInvestment) / INVESTMENT_STEP;

                                                                            const newReach =
                                                                                Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                                steps * REACH_STEP;

                                                                            onInputChange("reach", newReach);
                                                                        }
                                                                    }}

                                                                    onBlur={() => {
                                                                        let value = Number(formData.investment);

                                                                        if (!value || value < baseInvestment) {
                                                                            value = baseInvestment;
                                                                        }

                                                                        if (value > MAX_LIMIT) {
                                                                            value = MAX_LIMIT;
                                                                        }

                                                                        onInputChange("investment", value);

                                                                        const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                                        const newReach =
                                                                            Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                            steps * REACH_STEP;

                                                                        onInputChange("reach", newReach);
                                                                    }}

                                                                    inputProps={{ min: 0 }}

                                                                    sx={{ width: "180px" }}
                                                                />
                                                                {/* Value */}
                                                                <Typography sx={{ fontWeight: 700, color: "#1e40af" }}>
                                                                    ₹{formData.investment || 0}
                                                                </Typography>

                                                                {/* Input */}

                                                            </Box>
                                                        </Box>

                                                        {/* Slider */}
                                                        <Slider
                                                            value={
                                                                formData.investment === "" || formData.investment < baseInvestment
                                                                    ? baseInvestment
                                                                    : Number(formData.investment)
                                                            }
                                                            min={baseInvestment}
                                                            max={MAX_LIMIT}
                                                            step={INVESTMENT_STEP}
                                                            onChange={(e, val) => {
                                                                const value = Number(val);

                                                                onInputChange("investment", value);

                                                                const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                                const newReach =
                                                                    Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                    steps * REACH_STEP;

                                                                onInputChange("reach", newReach);
                                                            }}
                                                            sx={{ color: "#3b82f6" }}
                                                        />

                                                        {/* Footer */}
                                                        <Typography sx={{ fontSize: "11px", color: "#6b7280" }}>
                                                            Minimum budget: ₹{baseInvestment}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                                            <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                                                                Reach
                                                            </Typography>
                                                            <Typography sx={{ fontWeight: 700, color: "#059669" }}>
                                                                {/* ✅ formData.reach is now set on load, so always shows correctly */}
                                                                {Number(formData.reach ?? billing?.reach ?? 0).toLocaleString()} users
                                                            </Typography>
                                                        </Box>

                                                        <Slider
                                                            value={Number(formData.reach ?? billing?.reach ?? 0)}
                                                            min={billing?.reach ?? 0}
                                                            max={10000}
                                                            step={REACH_STEP}
                                                            onChange={(e, val) => {
                                                                onInputChange("reach", val);

                                                                const steps = (val - (billing?.reach ?? 0)) / REACH_STEP;
                                                                const newInvestment = baseInvestment + steps * INVESTMENT_STEP;
                                                                onInputChange("investment", newInvestment);
                                                            }}
                                                            sx={{ color: "#10b981" }}
                                                        />
                                                    </Box>
                                                    <Box sx={{ mt: 3 }}>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                mb: 1
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "13px",
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                Duration
                                                            </Typography>

                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    color: "#1e40af"
                                                                }}
                                                            >
                                                                {formData.days || 0} days
                                                            </Typography>
                                                        </Box>

                                                        <Slider
                                                            value={formData.days || 0}
                                                            min={0}
                                                            max={30}
                                                            disabled
                                                            sx={{
                                                                color: "#8b5cf6"
                                                            }}
                                                        />
                                                    </Box>
                                                </>
                                            )}
                                            {/* 🟣 Duration */}


                                            {/* 🟢 Reach */}


                                        </Box>
                                        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>

                                            {/* Start Date */}
                                            <Box sx={{ flex: 1 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        color: "#374151",
                                                        mb: 0.8
                                                    }}
                                                >
                                                    Start Date
                                                </Typography>

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type="date"
                                                    value={formData.startDate}
                                                    onChange={(e) => {

                                                        const startDate = e.target.value;

                                                        onInputChange("startDate", startDate);

                                                        // AUTO CALCULATE DAYS
                                                        if (formData.endDate) {

                                                            const start = new Date(startDate);
                                                            const end = new Date(formData.endDate);

                                                            const diffTime = end - start;

                                                            const diffDays =
                                                                Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                                            if (diffDays >= 0) {
                                                                onInputChange("days", diffDays);
                                                            }
                                                        }
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{
                                                        min: new Date().toISOString().split("T")[0]
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "12px",
                                                            backgroundColor: "#f8fafc"
                                                        }
                                                    }}
                                                />
                                            </Box>

                                            {/* END DATE */}
                                            <Box sx={{ flex: 1 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        color: "#374151",
                                                        mb: 0.8
                                                    }}
                                                >
                                                    End Date
                                                </Typography>

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type="date"
                                                    value={formData.endDate}
                                                    onChange={(e) => {

                                                        const endDate = e.target.value;

                                                        onInputChange("endDate", endDate);

                                                        // AUTO CALCULATE DAYS
                                                        if (formData.startDate) {

                                                            const start = new Date(formData.startDate);
                                                            const end = new Date(endDate);

                                                            const diffTime = end - start;

                                                            const diffDays =
                                                                Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                                            if (diffDays >= 0) {
                                                                onInputChange("days", diffDays);
                                                            }
                                                        }
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{
                                                        min:
                                                            formData.startDate ||
                                                            new Date().toISOString().split("T")[0]
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "12px",
                                                            backgroundColor: "#f8fafc"
                                                        }
                                                    }}
                                                />
                                            </Box>

                                        </Box>


                                        <Divider sx={{ mb: 3 }} />

                                        {/* ── Dates Section ── */}




                                        {/* ✅ Selected Locations Tags */}
                                        {formData.targetLocations?.length > 0 && (
                                            <Box sx={{
                                                p: 2, backgroundColor: "#f8fafc",
                                                border: "1px solid #e2e8f0", borderRadius: "10px", mb: 3
                                            }}>
                                                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#6b7280", mb: 1.5 }}>
                                                    📍 {formData.targetLocations.length} Location(s) Selected
                                                </Typography>
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                    {formData.targetLocations.map((loc, idx) => (
                                                        <Chip
                                                            key={idx}
                                                            label={`📍 ${loc.name}`}
                                                            onDelete={() => {
                                                                const updated = formData.targetLocations.filter((_, i) => i !== idx);
                                                                onInputChange("targetLocations", updated);
                                                            }}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "#eff6ff", color: "#1e40af",
                                                                fontWeight: 600, fontSize: "12px",
                                                                border: "1px solid #bfdbfe", borderRadius: "8px",
                                                                "& .MuiChip-deleteIcon": { color: "#3b82f6" }
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}



                                        {/* ── Navigation ── */}
                                        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, }}>
                                            <Button
                                                variant="outlined" size="large"
                                                startIcon={<ArrowLeft size={18} />}
                                                onClick={onBack}
                                                sx={{
                                                    borderRadius: "10px", textTransform: "none", fontWeight: 600,
                                                    borderColor: "#e5e7eb", color: "#6b7280",
                                                    "&:hover": { backgroundColor: "#f9fafb", borderColor: "#d1d5db" }
                                                }}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                disabled={isSubmitted} // 🔥 disables button after click
                                                onClick={() => {
                                                    setIsSubmitted(true);
                                                    setShowPayment(true);

                                                    setTimeout(() => {
                                                        if (adPreviewRef?.current) {
                                                            const container = adPreviewRef.current;

                                                            container.scrollTo({
                                                                top: container.scrollHeight,
                                                                behavior: "smooth"
                                                            });
                                                        }
                                                    }, 100);
                                                }}
                                                sx={{
                                                    borderRadius: "10px",
                                                    textTransform: "none",
                                                    fontWeight: 600,
                                                    backgroundColor: isSubmitted ? "#cbd5f5" : "#f97316", // disabled color
                                                    color: "#fff",
                                                    "&:hover": {
                                                        backgroundColor: isSubmitted ? "#cbd5f5" : "#ea580c"
                                                    }
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </Box>

                                    </CardContent>
                                </Card>



                            </Box>

                        ) : (

                            /* ================= NORMAL (LEADS Data code.) ================= */
                            <>
                                <Box sx={{ p: { xs: 2, md: 3, borderRadius: "16px", } }}>
                                    <Card elevation={3} sx={{ marginTop: "-63px", borderRadius: "16px", background: "transparent", boxShadow: "none" }}>
                                        <CardContent sx={{ p: { xs: 3, md: 4, } }}>

                                            {/* ✅ MAIN ROW */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",   // ✅ MAIN FIX various data not founded in the real 
                                                    gap: 3
                                                }}
                                            >

                                                {/* 🔵 Investment */}
                                                <Box>
                                                    {/* Header */}
                                                    <Box sx={{ mb: 2 }}>
                                                        {/* 🔥 Top Label */}
                                                        <Typography sx={{ fontSize: "13px", fontWeight: 600, mb: 1 }}>
                                                            Investment
                                                        </Typography>

                                                        {/* 🔽 Bottom Row (Value + Input) */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                gap: 2
                                                            }}
                                                        >


                                                            <TextField
                                                                size="small"
                                                                type="number"
                                                                value={formData.investment ?? ""}
                                                                placeholder="Enter amount"

                                                                onChange={(e) => {
                                                                    const value = e.target.value;

                                                                    if (value === "") {
                                                                        onInputChange("investment", "");
                                                                        return;
                                                                    }

                                                                    const num = Number(value);

                                                                    // ✅ mark as manual change
                                                                    isDaysUpdate.current = false;

                                                                    onInputChange("investment", num);

                                                                    if (!isNaN(num)) {
                                                                        const steps = (num - baseInvestment) / INVESTMENT_STEP;

                                                                        const newReach =
                                                                            Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                            steps * REACH_STEP;

                                                                        // ✅ update reach ONLY if not from days
                                                                        if (!isDaysUpdate.current) {
                                                                            onInputChange("reach", newReach);
                                                                        }
                                                                    }
                                                                }}

                                                                onBlur={() => {
                                                                    let value = Number(formData.investment);

                                                                    if (!value || value < baseInvestment) {
                                                                        value = baseInvestment;
                                                                    }

                                                                    if (value > MAX_LIMIT) {
                                                                        value = MAX_LIMIT;
                                                                    }

                                                                    // ✅ mark manual change
                                                                    isDaysUpdate.current = false;

                                                                    onInputChange("investment", value);

                                                                    const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                                    const newReach =
                                                                        Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                        steps * REACH_STEP;

                                                                    if (!isDaysUpdate.current) {
                                                                        onInputChange("reach", newReach);
                                                                    }
                                                                }}

                                                                inputProps={{ min: 0 }}
                                                                sx={{ width: "180px" }}
                                                            />
                                                            {/* Value */}
                                                            <Typography sx={{ fontWeight: 700, color: "#1e40af" }}>
                                                                ₹{formData.investment || 0}
                                                            </Typography>

                                                            {/* Input */}

                                                        </Box>
                                                    </Box>

                                                    {/* Slider */}
                                                    <Slider
                                                        value={
                                                            formData.investment === "" || formData.investment < baseInvestment
                                                                ? baseInvestment
                                                                : Number(formData.investment)
                                                        }
                                                        min={baseInvestment}
                                                        max={MAX_LIMIT}
                                                        step={INVESTMENT_STEP}
                                                        onChange={(e, val) => {
                                                            const value = Number(val);

                                                            // ✅ mark manual change
                                                            isDaysUpdate.current = false;

                                                            onInputChange("investment", value);

                                                            const steps = (value - baseInvestment) / INVESTMENT_STEP;

                                                            const newReach =
                                                                Math.floor(baseInvestment / INVESTMENT_STEP) * REACH_STEP +
                                                                steps * REACH_STEP;

                                                            if (!isDaysUpdate.current) {
                                                                onInputChange("reach", newReach);
                                                            }
                                                        }}
                                                        sx={{ color: "#3b82f6" }}
                                                    />

                                                    {/* Footer */}
                                                    <Typography sx={{ fontSize: "11px", color: "#6b7280" }}>
                                                        Minimum budget: ₹{baseInvestment}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                                        <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                                                            Reach
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 700, color: "#059669" }}>
                                                            {/* ✅ formData.reach is now set on load, so always shows correctly */}
                                                            {Number(formData.reach ?? billing?.reach ?? 0).toLocaleString()} users
                                                        </Typography>
                                                    </Box>

                                                    <Slider
                                                        value={Number(formData.reach ?? billing?.reach ?? 0)}
                                                        min={billing?.reach ?? 0}
                                                        max={10000}
                                                        step={REACH_STEP}
                                                        onChange={(e, val) => {
                                                            onInputChange("reach", val);
                                                            const steps = (val - (billing?.reach ?? 0)) / REACH_STEP;
                                                            const newInvestment = baseInvestment + steps * INVESTMENT_STEP;
                                                            onInputChange("investment", newInvestment);
                                                        }}
                                                        sx={{ color: "#10b981" }}
                                                    />
                                                </Box>
                                                {/* 🟣 Duration */}
                                                <Box sx={{ mt: 3 }}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            mb: 1
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize: "13px",
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            Duration
                                                        </Typography>

                                                        <Typography
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: "#1e40af"
                                                            }}
                                                        >
                                                            {formData.days || 0} days
                                                        </Typography>
                                                    </Box>

                                                    <Slider
                                                        value={formData.days || 0}
                                                        min={0}
                                                        max={30}
                                                        disabled
                                                        sx={{
                                                            color: "#8b5cf6"
                                                        }}
                                                    />
                                                </Box>
                                                {/* 🟢 Reach */}


                                            </Box>
                                            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>

                                                {/* Start Date */}
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "13px",
                                                            fontWeight: 600,
                                                            color: "#374151",
                                                            mb: 0.8
                                                        }}
                                                    >
                                                        Start Date
                                                    </Typography>

                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        type="date"
                                                        value={formData.startDate}
                                                        onChange={(e) => {

                                                            const startDate = e.target.value;

                                                            onInputChange("startDate", startDate);

                                                            // AUTO CALCULATE DAYS
                                                            if (formData.endDate) {

                                                                const start = new Date(startDate);
                                                                const end = new Date(formData.endDate);

                                                                const diffTime = end - start;

                                                                const diffDays =
                                                                    Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                                                if (diffDays >= 0) {
                                                                    onInputChange("days", diffDays);
                                                                }
                                                            }
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{
                                                            min: new Date().toISOString().split("T")[0]
                                                        }}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: "12px",
                                                                backgroundColor: "#f8fafc"
                                                            }
                                                        }}
                                                    />
                                                </Box>

                                                {/* END DATE */}
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "13px",
                                                            fontWeight: 600,
                                                            color: "#374151",
                                                            mb: 0.8
                                                        }}
                                                    >
                                                        End Date
                                                    </Typography>

                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        type="date"
                                                        value={formData.endDate}
                                                        onChange={(e) => {

                                                            const endDate = e.target.value;

                                                            onInputChange("endDate", endDate);

                                                            // AUTO CALCULATE DAYS
                                                            if (formData.startDate) {

                                                                const start = new Date(formData.startDate);
                                                                const end = new Date(endDate);

                                                                const diffTime = end - start;

                                                                const diffDays =
                                                                    Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                                                if (diffDays >= 0) {
                                                                    onInputChange("days", diffDays);
                                                                }
                                                            }
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{
                                                            min:
                                                                formData.startDate ||
                                                                new Date().toISOString().split("T")[0]
                                                        }}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: "12px",
                                                                backgroundColor: "#f8fafc"
                                                            }
                                                        }}
                                                    />
                                                </Box>

                                            </Box>


                                            <Divider sx={{ mb: 3 }} />

                                            {/* ── Dates Section ── */}




                                            {/* ✅ Selected Locations Tags */}
                                            {formData.targetLocations?.length > 0 && (
                                                <Box sx={{
                                                    p: 2, backgroundColor: "#f8fafc",
                                                    border: "1px solid #e2e8f0", borderRadius: "10px", mb: 3
                                                }}>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#6b7280", mb: 1.5 }}>
                                                        📍 {formData.targetLocations.length} Location(s) Selected
                                                    </Typography>
                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                        {formData.targetLocations.map((loc, idx) => (
                                                            <Chip
                                                                key={idx}
                                                                label={`📍 ${loc.name}`}
                                                                onDelete={() => {
                                                                    const updated = formData.targetLocations.filter((_, i) => i !== idx);
                                                                    onInputChange("targetLocations", updated);
                                                                }}
                                                                size="small"
                                                                sx={{
                                                                    backgroundColor: "#eff6ff", color: "#1e40af",
                                                                    fontWeight: 600, fontSize: "12px",
                                                                    border: "1px solid #bfdbfe", borderRadius: "8px",
                                                                    "& .MuiChip-deleteIcon": { color: "#3b82f6" }
                                                                }}
                                                            />
                                                        ))}
                                                    </Box>
                                                </Box>
                                            )}



                                            {/* ── Navigation ── */}
                                            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, }}>
                                                <Button
                                                    variant="outlined" size="large"
                                                    startIcon={<ArrowLeft size={18} />}
                                                    onClick={onBack}
                                                    sx={{
                                                        borderRadius: "10px", textTransform: "none", fontWeight: 600,
                                                        borderColor: "#e5e7eb", color: "#6b7280",
                                                        "&:hover": { backgroundColor: "#f9fafb", borderColor: "#d1d5db" }
                                                    }}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    disabled={isSubmitted} // 🔥 disables button after click
                                                    onClick={() => {
                                                        setIsSubmitted(true);
                                                        setShowPayment(true);

                                                        setTimeout(() => {
                                                            if (adPreviewRef?.current) {
                                                                const container = adPreviewRef.current;

                                                                container.scrollTo({
                                                                    top: container.scrollHeight,
                                                                    behavior: "smooth"
                                                                });
                                                            }
                                                        }, 100);
                                                    }}
                                                    sx={{
                                                        borderRadius: "10px",
                                                        textTransform: "none",
                                                        fontWeight: 600,
                                                        backgroundColor: isSubmitted ? "#cbd5f5" : "#f97316", // disabled color
                                                        color: "#fff",
                                                        "&:hover": {
                                                            backgroundColor: isSubmitted ? "#cbd5f5" : "#ea580c"
                                                        }
                                                    }}
                                                >
                                                    Submit
                                                </Button>
                                            </Box>

                                        </CardContent>
                                    </Card>



                                </Box>

                            </>

                        )
                        }
                        {/* ✅ CONDITION END */}

                    </CardContent >
                </Card >
            </Box >
        );
    }

    // ================= REVIEW STEP =================


};

export default BudgetReview;